import { Box, Button, Paper, Typography } from '@mui/material'
import React, { useState } from 'react'
import { exportKiddomTreeToSpreadsheet } from './utilities'
import { useGetTreeById } from 'shared/hooks/trees/hooks'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { googleUserAtom } from 'infrastructure/googleDrive'
import styled from '@emotion/styled'

const SectionPaper = styled(Paper)(() => ({
  padding: '24px',
  marginBottom: '24px',
}))

interface ExportStandardsProps {
  treeId: string
  treeVer: string
}

export function ExportStandards({ treeId, treeVer }: ExportStandardsProps) {
  const { tree } = useGetTreeById({ treeId, versionId: treeVer })
  const guser = useAtomValue(googleUserAtom)
  const [spreadsheetId, setSpreadsheetId] = useState<string>()
  const [exporting, setExporting] = useState(false)

  if (!tree) {
    return <Box>Loading tree...</Box>
  }

  return (
    <SectionPaper>
      <Typography variant="h5" gutterBottom>
        Export Spreadsheet
      </Typography>
      <Button
        disabled={exporting}
        onClick={() => {
          setExporting(true)
          exportKiddomTreeToSpreadsheet(
            tree,
            guser.credential?.accessToken || '',
          ).then((s) => {
            setSpreadsheetId(s)
            setExporting(false)
          })
        }}
      >
        {exporting ? 'Exporting...' : 'Export Spreadsheet'}
      </Button>

      {spreadsheetId && (
        <Box mt={2}>
          Exported to:{' '}
          <a
            href={`https://docs.google.com/spreadsheets/d/${spreadsheetId}`}
            target="_blank"
            rel="noreferrer"
          >
            https://docs.google.com/spreadsheets/d/{spreadsheetId}
          </a>
        </Box>
      )}
    </SectionPaper>
  )
}
